<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-0 bg-logo"
        style="background-color:#3f3939"
      >
        <!-- <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="logo"
          />
        </div> -->
      </b-col>

      <b-col
        lg="4"
        class="auth-bg px-2 p-lg-5"
        style="display: grid;"
      >
        <b-card-title
          title-tag="h2"
          class="font-weight-bold mb-1 card-title-top"
        >
          <font-awesome-icon
            :icon="faUserFriends"
            class="mr-50"
          /> Portal do cliente
        </b-card-title>

        <div>
          <div style="display: flex;">
            <b-card-title
              title-tag="h2"
              class="font-weight-bold mb-1"
              style="font-size: 22px;"
            >
              Acesse sua conta
            </b-card-title>
            <manual-cliente
              tooltip
              style="margin-left: 2px;"
            />
          </div>
          <b-card-sub-title
            class="mb-2"
            style="color: #6e6b7b !important;"
          >
            Informe seus Dados de Acesso
          </b-card-sub-title>
          <!-- form -->
          <validation-observer ref="validacao">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="E-mail"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="form.login"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="pessoa@email.com.br"
                  />
                  <small class="text-danger">{{ errors.length > 0 ? 'Digite um e-mail válido' : null }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Senha</label>
                  <b-link @click="forgotPassword()">
                    <small>Esqueci minha senha</small>
                  </b-link>
                </div>
                <senha-input
                  v-model="form.senha"
                  required
                />
                <small class="text-danger">{{ loginError }}</small>
              </b-form-group>

              <!-- checkbox
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Lembrar de mim
                </b-form-checkbox>
              </b-form-group>
              -->
              <b-alert
                v-if="esqueci"
                show
                :variant="esqueci.error ? 'danger' : 'success'"
                :class="{ 'alert-danger': esqueci.error, 'alert-primary': !esqueci.error }"
              >
                {{ esqueci.message }}
              </b-alert>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="autenticar"
              >
                Entrar
              </b-button>
            </b-form>
          </validation-observer>
        </div>
        <div style="display: flex; flex-direction: column; justify-content: end;">
          <manual-cliente :tooltip="false" />
        </div>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.card-title-top {
  display: flex;
  justify-content: center;
  font-size: 1rem;
}
</style>

<script>
/* eslint-disable global-require */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faUserFriends,
} from '@fortawesome/free-solid-svg-icons'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { mapActions } from 'vuex'
import useJwt from '@/auth/jwt/useJwt'
import { clearLoggedIn, updateAbility } from '@/auth/utils'

export default {
  components: {
    FontAwesomeIcon,
    ValidationProvider,
    ValidationObserver,
    SenhaInput: () => import('@/shared/components/senha-input/SenhaInput.vue'),
    ManualCliente: () => import('@/app-modulo/comuns/manual-cliente/ManualCliente.vue'),
  },
  data() {
    return {
      faUserFriends,
      form: {
        login: '',
        senha: '',
      },
      esqueci: null,
      loginError: '',
      logo: require('@/assets/images/logo/logocompleta.png'),
      required,
      email,
    }
  },
  computed: {
    imgUrl() {
      return require('@/assets/images/pages/logininterno.png')
    },
  },
  created() {
    clearLoggedIn()
  },
  methods: {
    ...mapActions('empresaExGlobal', ['setEmpresa', 'setEscolherEmpresa']),
    autenticar() {
      this.loginError = ''
      this.$refs.validacao.validate()
        .then(() => {
          this.form.login = this.form.login.trim()
          useJwt.login(this.form)
            .then(response => {
              if (response.data.alterarSenha) {
                this.$router.push({ name: 'alterar-senha-externo' })
              } else {
                useJwt.setToken(response.data.accessToken)
                localStorage.setItem('userData', JSON.stringify(response.data.userData))
                localStorage.setItem('empresaSelecionada', null)
                updateAbility(this.$ability)
                if (response.data.userData.empresas.length > 1) {
                  this.setEscolherEmpresa(true)
                  this.$router.push({ name: 'selecionar-empresa' })
                } else {
                  this.setEmpresa(response.data.userData.empresas[0])
                  this.setEscolherEmpresa(false)
                  this.$router.push({ name: 'portaldocumentos-externo' })
                }
              }
            })
            .catch(error => {
              this.loginError = error.response.data.message
              this.$refs.validacao.setErrors({ Password: error.response.data.message })
            })
        })
    },
    forgotPassword() {
      this.form.login = this.form.login.trim()
      useJwt.esqueciSenha(this.form.login)
        .then(() => {
          this.esqueci = {
            message: `E-mail enviado com sucesso para ${this.form.login}`,
            error: false,
          }
        })
        .catch(err => {
          const msg = (!err.message || !err.response.data)
            ? 'Não foi possível enviar o email de recuperação de senha. Contate o administrador'
            : err.response.data.message

          this.esqueci = {
            message: msg,
            error: true,
          }
        })
    },
  },
}
</script>
